import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    cursor: 'inherit',
    width: 99,
    height: 28,
    fontSize: '0.875rem',
    fontWeight: 500,
    borderRadius: 4,
    border: '1px solid',
    alignItems: 'center',
    justifyContent: 'center',

    '&.color': {
      '&--default': {
        color: 'var(--color-chip-font-default)',
        borderColor: 'var(--color-chip-border-default)',
        backgroundColor: 'var(--color-chip-bg-default)',
      },
      '&--primary': {
        backgroundColor: 'var(--color-chip-bg-primary)',
        color: 'var(--color-chip-font-primary)',
        borderColor: 'var(--color-chip-font-primary)',
      },
      '&--safe': {
        backgroundColor: 'var(--color-chip-bg-safe)',
        color: 'var(--color-chip-font-safe)',
        borderColor: 'var(--color-chip-font-safe)',
      },
      '&--danger': {
        backgroundColor: 'var(--color-chip-bg-danger)',
        color: 'var(--color-chip-font-danger)',
        borderColor: 'var(--color-chip-font-danger)',
      },
      '&--warning': {
        backgroundColor: 'var(--color-chip-bg-warning)',
        color: 'var(--color-chip-font-warning)',
        borderColor: 'var(--color-chip-font-warning)',
      },
    },
  },
}));

const statuses = {
  TRADE_ACTIVE: {
    text: 'Trade Active',
    color: 'safe',
  },
  TRADE_CLOSED: {
    text: 'Trade Closed',
    color: 'danger',
  },
  READY: {
    text: 'Ready',
    color: 'warning',
  },
  NOT_RUNNING: {
    text: 'Disabled',
    color: 'default',
  },
};

const StatusPill = ({ status = 'NOT_RUNNING', enabled = false }) => {
  const classes = useStyles();
  let { text, color } =
    status && statuses[status] && statuses[status].text
      ? statuses[status]
      : statuses['NOT_RUNNING'];

  if ((!status || status === 'NOT_RUNNING') && enabled) {
    text = 'Enabled';
    color = 'primary';
  }

  return <span className={`${classes.root} color--${color}`}>{text}</span>;
};

export default StatusPill;
